import {
  vs2ngaGlobalReleaseConstants,
  addVs2ngaGlobalReleaseConstants,
  editVs2ngaGlobalReleaseConstants,
} from "../_redux-constants";

export function vs2ngaGlobalReleaseReducer(
  state = {
    vs2ngaGlobalReleaseLoading: false,
    vs2ngaGlobalReleaseData: null,
    vs2ngaGlobalReleaseError: null,

    addVs2ngaGlobalReleaseLoading: false,
    addVs2ngaGlobalReleaseData: null,
    addVs2ngaGlobalReleaseError: null,

    editVs2ngaGlobalReleaseLoading: false,
    editVs2ngaGlobalReleaseData: null,
    editVs2ngaGlobalReleaseError: null,
  },
  action
) {
  switch (action.type) {
    case vs2ngaGlobalReleaseConstants.VS2NGA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        vs2ngaGlobalReleaseLoading: true,
        vs2ngaGlobalReleaseData: null,
        vs2ngaGlobalReleaseError: null,
        addVs2ngaGlobalReleaseLoading: false,
        addVs2ngaGlobalReleaseData: null,
        addVs2ngaGlobalReleaseError: null,
      });
    case vs2ngaGlobalReleaseConstants.VS2NGA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaGlobalReleaseLoading: false,
        vs2ngaGlobalReleaseData: action.data,
      });
    case vs2ngaGlobalReleaseConstants.VS2NGA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        vs2ngaGlobalReleaseLoading: false,
        vs2ngaGlobalReleaseData: null,
        vs2ngaGlobalReleaseError: action.error,
      });

    case addVs2ngaGlobalReleaseConstants.ADD_VS2NGA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        addVs2ngaGlobalReleaseLoading: true,
        addVs2ngaGlobalReleaseData: null,
        addVs2ngaGlobalReleaseError: null,
      });
    case addVs2ngaGlobalReleaseConstants.ADD_VS2NGA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        addVs2ngaGlobalReleaseLoading: false,
        addVs2ngaGlobalReleaseData: action.data,
      });
    case addVs2ngaGlobalReleaseConstants.ADD_VS2NGA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        addVs2ngaGlobalReleaseLoading: false,
        addVs2ngaGlobalReleaseData: null,
        addVs2ngaGlobalReleaseError: action.error,
      });

    case editVs2ngaGlobalReleaseConstants.EDIT_VS2NGA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        editVs2ngaGlobalReleaseLoading: true,
        editVs2ngaGlobalReleaseData: null,
        editVs2ngaGlobalReleaseError: null,
      });
    case editVs2ngaGlobalReleaseConstants.EDIT_VS2NGA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        editVs2ngaGlobalReleaseLoading: false,
        editVs2ngaGlobalReleaseData: action.data,
      });
    case editVs2ngaGlobalReleaseConstants.EDIT_VS2NGA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        editVs2ngaGlobalReleaseLoading: false,
        editVs2ngaGlobalReleaseData: null,
        editVs2ngaGlobalReleaseError: action.error,
      });

    default:
      return state;
  }
}
